import React from 'react';

import { styled } from '../theme';
import { CommonComponentProps } from '../types/components';
import SvgIcon from './SvgIcon';
import Text from './Text';

type Props = CommonComponentProps & {
    href?: string;
    beforeIconSrc?: string;
    beforeIconAlt?: string;
    disabled?: boolean;
    target?: string;
    centered?: boolean;
    checkIsActive?: () => boolean;
    styles?: React.CSSProperties;
};

type SideMenuLinkProps = {
    disabled?: boolean;
    isActive?: boolean;
    styles?: React.CSSProperties;
};

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
    color: 'inherit',
}));

const SideMenuLink = styled(Text.withComponent('a'))<SideMenuLinkProps>(
    ({ theme, disabled, isActive, styles }) => ({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit',
        minHeight: 40,
        fontWeight: theme.typography.fontWeight.base,
        ':hover, :focus': {
            color: theme.color.primary1,
            svg: {
                color: theme.color.primary1,
            },
            textDecoration: 'none',
        },
        ':active, &.active': {
            fontWeight: theme.typography.fontWeight.medium,
            color: theme.color.primary1,
            svg: {
                color: theme.color.primary1,
            },
        },
        ...(disabled && {
            color: theme.color.gray70,
            cursor: 'default',
            pointerEvents: 'none',
        }),
        '* + *': {
            marginLeft: 15,
        },
        ...(isActive && {
            fontWeight: theme.typography.fontWeight.medium,
            color: theme.color.primary1,
            svg: {
                color: theme.color.primary1,
            },
        }),
        ...(styles && styles),
    })
);

export default React.forwardRef<HTMLAnchorElement, Props>(
    ({ children, beforeIconSrc, beforeIconAlt, checkIsActive, ...props }, ref) => (
        <SideMenuLink ref={ref} {...props} isActive={checkIsActive?.()}>
            {beforeIconSrc && (
                <StyledSvgIcon alt={beforeIconAlt || ''} src={beforeIconSrc} size="large" />
            )}
            {children}
        </SideMenuLink>
    )
);
